import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LangProvider } from "@/context/LangContext";
import { PrivacyProvider } from "@/context/PrivacyContext";
import PrivacyPolicyModal from "@/components/ui/PrivacyPolicyModal";
import Analytics from "@/components/ui/Analytics";
import HashScroll from "@/components/ui/HashScroll";
import CustomCursor from "@/components/ui/CustomCursor";
import AmbientLight from "@/components/ui/AmbientLight";
import HomePage from "@/pages/HomePage";
import CaseStudyPage from "@/pages/CaseStudyPage";
import BlogIndexPage from "@/pages/BlogIndexPage";
import BlogPostPage from "@/pages/BlogPostPage";

export default function App() {
  return (
    <LangProvider>
      <PrivacyProvider>
        <BrowserRouter>
          <CustomCursor />
          <AmbientLight />
          <Analytics />
          <HashScroll />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/realizacje/:slug" element={<CaseStudyPage />} />
            <Route path="/blog" element={<BlogIndexPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <PrivacyPolicyModal />
        </BrowserRouter>
      </PrivacyProvider>
    </LangProvider>
  );
}